import { IconLeftArrow } from './svg/icon-left-arrow';
import { IconRightArrow } from './svg/icon-right-arrow';
import { IconClose } from './svg/icon-close';
import { IconExport } from './svg/icon-export';
import { IconLogo } from './svg/icon-logo';
import { IconLogout } from './svg/icon-logout';
import { IconCheckboxChecked } from './svg/icon-checkbox-checked';
import { IconXStrong } from './svg/icon-x-strong';
import { IconPlusCircleFilled } from './svg/icon-plus-circle-filled';
import { IconMediaSrt } from './svg/icon-media-srt';
import { IconMediaVideo } from './svg/icon-media-video';
import { IconRadioChecked2 } from './svg/icon-radio-checked2';
import { IconRadioUnchecked2 } from './svg/icon-radio-unchecked2';
import { IconSeries } from './svg/icon-series';
import { IconMovie } from './svg/icon-movie';
import { IconSeason } from './svg/icon-season';
import { IconEvent } from './svg/icon-event';
import { IconEpisode } from './svg/icon-episode';
import { IconOther } from './svg/icon-other';
import { IconComplete } from './svg/icon-complete';
import { IconIncomplete } from './svg/icon-incomplete';
import { IconAustin } from './svg/icon-austin';
import { IconDallas } from './svg/icon-dallas';
import { IconActive } from './svg/icon-active';
import { IconInactive } from './svg/icon-inactive';
import { IconLocked } from './svg/icon-locked';
import { IconCloseWhite } from './svg/icon-close-white';
import { IconAustinDescription } from './svg/icon-austin-description';
import { IconDallasDescription } from './svg/icon-dallas-description';
import { IconScrollLeft } from './svg/icon-scroll-left';
import { IconScrollRight } from './svg/icon-scroll-right';
import { IconStatusLocked } from './svg/icon-status-locked';
import { IconStatusUnlocked } from './svg/icon-status-unlocked';
import { IconThreeDots } from './svg/icon-three-dots';
import { IconDownload } from './svg/icon-download';
import { IconCopy } from './svg/icon-copy';
import { IconLink } from './svg/icon-link';
import { IconInfo } from './svg/icon-info';
import { IconComment } from './svg/icon-comment';
import { IconTag } from './svg/icon-tag';
import { IconEdit } from './svg/icon-edit';
import { IconLoading } from './svg/icon-loading';
import { IconCollection } from './svg/icon-collection';
import { IconRightArrowCarousel } from './svg/icon-right-arrow-carousel';
import { IconLeftArrowCarousel } from "./svg/icon-left-arrow-carousel"

export type KonIconName =
  | 'calendar'
  | 'left-arrow'
  | 'right-arrow'
  | 'close'
  | 'export'
  | 'x'
  | 'check-circle-filled'
  | 'comment-x-filled'
  | 'logo'
  | 'logout'
  | 'caret-down'
  | 'caret-up'
  | 'radio-checked-sm'
  | 'radio-unchecked-sm'
  | 'checkbox-checked' 
  | 'checkbox-checked-filled'
  | 'checkbox-filled'
  | 'x-strong'
  | 'plus-circle-filled'
  | 'media-srt'
  | 'media-video'
  | 'list-view'
  | 'thumbnail-view'
  | 'arrow-left'
  | 'arrow-right'
  | 'export-csv'
  | 'radio-checked2'
  | 'radio-unchecked2'
  | 'refresh'
  | 'series'
  | 'movie'
  | 'season'
  | 'event'
  | 'episode'
  | 'other'
  | 'active'
  | 'inactive'
  | 'DALLAS'
  | 'AUSTIN'
  | 'complete'
  | 'incomplete'
  | 'locked'
  | 'close-white'
  | 'austin-description'
  | 'dallas-description'
  | 'scroll-left'
  | 'scroll-right'
  | 'status-locked'
  | 'status-unlocked'
  | 'three-dots'
  | 'download'
  | 'copy'
  | 'link'
  | 'info'
  | 'comment'
  | 'tag'
  | 'edit'
  | 'loading'
  | 'magnifying-glass-plus-circle'
  | 'collection'
  | 'arrow-right-carousel'
  | 'arrow-left-carousel'




export const CUSTOM_ICONS: Partial<Record<KonIconName, string>> = {
      'left-arrow': IconLeftArrow,
      'right-arrow': IconRightArrow,
      'close': IconClose,
      'export': IconExport,
      'logo': IconLogo,
      'logout': IconLogout,
      'checkbox-checked': IconCheckboxChecked,
      'x-strong': IconXStrong,
      'plus-circle-filled': IconPlusCircleFilled,
      'media-srt': IconMediaSrt,
      'media-video': IconMediaVideo,
      'radio-checked2': IconRadioChecked2,
      'radio-unchecked2': IconRadioUnchecked2,
      'series': IconSeries,
      'movie': IconMovie,
      'season': IconSeason,
      'event': IconEvent,
      'episode': IconEpisode,
      'other': IconOther,
      'complete': IconComplete,
      'incomplete': IconIncomplete,
      'AUSTIN': IconAustin,
      'DALLAS': IconDallas,
      'active': IconActive,
      'inactive': IconInactive,
      'locked': IconLocked,
      'close-white': IconCloseWhite,
      'austin-description': IconAustinDescription,
      'dallas-description': IconDallasDescription,
      'scroll-left': IconScrollLeft,
      'scroll-right': IconScrollRight,
      'status-locked': IconStatusLocked,
      'status-unlocked': IconStatusUnlocked,
      'three-dots': IconThreeDots,
      'download': IconDownload,
      'copy': IconCopy,
      'link': IconLink,
      'info': IconInfo,
      'comment': IconComment,
      'tag': IconTag,
      'edit': IconEdit,
      'loading': IconLoading,
      'collection': IconCollection,
      'arrow-right-carousel': IconRightArrowCarousel,
      'arrow-left-carousel': IconLeftArrowCarousel,
    }